import React, { useEffect } from 'react'
import { useState } from 'react';
import { Box, Button, Menu, MenuItem, TableBody, Typography } from '@mui/material';


export default function Product({productData}) {
    const [inPutlist, setInputList] = useState([
        {
            attachment: '',
        },
    ])
 
    const onChangeHandle = (e) => {

        const type = 'attachment'

        const list = [...inPutlist];
        list[index][type] = e
        setInputList(list)
        
        return

    }

    

    useEffect(()=>{

        productData(inPutlist)

    },[inPutlist])

    const [index, setIndex] = useState(0)

    const handleaddclick = () => {

        setIndex(inPutlist.length)

        const _inPutlist = [...inPutlist]
        _inPutlist.push({
            attachment: "",
        })
        setInputList(_inPutlist)
    }

    const removeInputFieldsq = (index) => {
        const rows = [...inPutlist];
        rows.splice(1, 1);
        setInputList(rows);
    }

  return (
    <>
 <Box 
  sx={{ 
    mb: 4, 
    p: 3, 
    backgroundColor: "#ffffff", 
    borderRadius: "16px", 
    border: "1px solid #E0E5F2",
    boxShadow: "0px 4px 15px rgba(0,0,0,0.02)"
  }}
>
  {/* Header */}
  <Box sx={{ mb: 2 }}>
    <Typography sx={{ color: "#1B2559", fontWeight: "800", fontSize: "15px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
      Product Name
    </Typography>
    <Typography sx={{ color: "#A3AED0", fontSize: "12px", fontWeight: "500", mt: 0.5 }}>
      You can add as many products as you want
    </Typography>
  </Box>

  {/* Inputs Container */}
  <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", mb: 3 }}>
    {inPutlist.map((data, index) => (
      <input
        key={data.id || index}
        placeholder={`Enter Product Name ${index + 1}...`}
        onChange={(e) => onChangeHandle(e.target.value, index)}
        style={{
          width: "100%",
          padding: "14px 16px",
          fontSize: "14px",
          color: "#2B3674",
          backgroundColor: "#F4F7FE",
          border: "2px solid transparent",
          borderRadius: "10px",
          outline: "none",
          transition: "all 0.2s ease",
          boxSizing: "border-box"
        }}
        onFocus={(e) => e.target.style.border = "2px solid #4318ff"}
        onBlur={(e) => e.target.style.border = "2px solid transparent"}
      />
    ))}
  </Box>

  {/* Action Buttons */}
  <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: "15px" }}>
    <Button
      onClick={handleaddclick}
      sx={{
        flex: 1,
        padding: "10px",
        backgroundColor: "#F8F9FF",
        color: "#4318ff",
        border: "1px dashed #4318ff",
        borderRadius: "10px",
        fontWeight: "700",
        textTransform: "none",
        fontSize: "14px",
        "&:hover": { backgroundColor: "#F4F7FE", border: "1px solid #4318ff" }
      }}
    >
      + Add More
    </Button>

    {inPutlist.length > 1 && (
      <Button
        onClick={() => {
          removeInputFieldsq(inPutlist.length - 1);
          setIndex(inPutlist.length - 2);
        }}
        sx={{
          flex: 1,
          padding: "10px",
          backgroundColor: "#FEE2E2",
          color: "#E31B23",
          border: "1px dashed #E31B23",
          borderRadius: "10px",
          fontWeight: "700",
          textTransform: "none",
          fontSize: "14px",
          "&:hover": { backgroundColor: "#FCD3D3", border: "1px solid #E31B23" }
        }}
      >
        - Remove Last
      </Button>
    )}
  </Box>

  <Typography sx={{ color: "#A3AED0", fontSize: "12px", fontWeight: "500", mt: 2, fontStyle: "italic" }}>
    * It is necessary to add at least one product
  </Typography>
</Box>
    </>
    
  )
}
